// extracted by mini-css-extract-plugin
export default {"AccountOwner":"bottombar_AccountOwner__ahdYV"};